
import { mapMutations } from 'vuex'
import AppModal from './AppModal.vue'
import ClassBox from './ClassBox.vue'
import AppSpin from '@/components/AppSpin.vue'

export default {
  name: 'ClassModal',
  components: {
    AppModal,
    ClassBox,
    AppSpin,
  },
  data() {
    return {
      classes: [],
      search: '',
    }
  },
  computed: {
    newClasses() {
      return this.$store.state.class.newClasses
    },
    oldClasses() {
      return this.$store.state.class.oldClasses
    },
  },
  watch: {
    search() {
      this.$store.commit('class/filterNewClasses', this.search)
    },
  },
  async mounted() {
    await this.$store.dispatch('class/getClasses')
  },
  methods: {
    ...mapMutations({ toggleClassModal: 'modal/toggleClassModal' }),
    changeClass(classe) {
      localStorage.classId = classe.id
      localStorage.className = classe.name
      localStorage.required_documents = classe.required_documents

      if (classe.url_links && classe.url_links.whatsapp) {
        localStorage.classWhatsapp = classe.url_links.whatsapp
      } else {
        localStorage.removeItem('classWhatsapp')
      }

      localStorage.removeItem('multiAgentIa')
      localStorage.removeItem('planningIa')
      localStorage.removeItem('questions')
      if (classe.services.length) {
        classe.services.forEach((element) => {
          if (element.type === 'MULTI_AGENT_IA') {
            localStorage.multiAgentIa = true
          }
          if (element.type === 'PLANNING_IA') {
            localStorage.planningIa = true
          }
          if (element.type === 'QUESTIONS') {
            localStorage.questions = true
          }
        })
      }
      if (classe.required_documents.length) {
        localStorage.required_documents = JSON.stringify(
          classe.required_documents
        )
      } else {
        localStorage.removeItem('required_documents')
      }
      this.$store.commit('modal/toggleClassModal')
      // window.location.href = '/'
      window.location.reload()
    },
  },
}
